let noop = () => {};

let initOption = function(option) {
    option.onClick = option.onClick || noop;
    option.onDblClick = option.onDblClick || noop;
    option.scaleSmall = option.scaleSmall || noop;
};

export default initOption;
